<div class="gateway-container">
  <router-outlet></router-outlet>
</div>
